import Cero from './Cero';

function App() {
  return <Cero />;
}

export default App;
